import { utils } from "./utils.js";

const phase = {
  none: "none",
  lookingForDelimiter: "lookingForDelimiter",
  lookingForDoubleQuotas: "lookingForDoubleQuotas",
};

export var csvLineParserFactory = function (source, delimiter) {
  const _source = source;
  const _delimiter = delimiter;
  const _lineBreak = "\n";
  const _doubleQuotas = '"';
  let _currentPhase = phase.none;
  let _startIndex = null;
  const _result = [];
  let _take = null;

  function setStartIndexIfNone(value) {
    if (!_startIndex) {
      _startIndex = value;
    }
  }

  function addField(field) {
    const trimmedField = field.trim();
    let normalizedField = trimmedField;
    if (field.length > 1) {
      if (
        field[0] === _doubleQuotas &&
        field[field.length - 1] === _doubleQuotas
      ) {
        normalizedField = utils.cutEdges(trimmedField);
      }
    }

    _result.push(normalizedField);

    _startIndex = null;
    _currentPhase = phase.none;

    const result = _take && _take <= _result.length;
    return result;
  }

  function resetStartIndex() {
    _startIndex = null;
  }

  function parse(fromIndex, take) {
    _take = take;
    for (let i = fromIndex ?? 0; i <= _source.length - 1; i++) {
      const currentCharacter = _source[i];
      switch (currentCharacter) {
        case _delimiter:
        case _lineBreak:
          if (_currentPhase === phase.none) {
            const field = _startIndex ? _source.substring(_startIndex, i) : "";
            if (addField(field)) {
              return {
                fields: _result,
                index: i,
              };
            }
          } else if (_currentPhase === phase.lookingForDelimiter) {
            const field = _source.substring(_startIndex, i);
            if (addField(field)) {
              return {
                fields: _result,
                index: i,
              };
            }
          }
          break;

        case _doubleQuotas:
          if (_currentPhase === phase.none) {
            setStartIndexIfNone(i);
            _currentPhase = phase.lookingForDoubleQuotas;
          } else if (_currentPhase === phase.lookingForDoubleQuotas) {
            const hasBackslashBefore = i - 1 >= 0 && _source[i - 1] === "\\";
            if (!hasBackslashBefore) {
              const hasQuoteAfter =
                i + 1 < _source.length && _source[i + 1] === _doubleQuotas;
              if (hasQuoteAfter) {
                i++;
              } else {
                _currentPhase = phase.lookingForDelimiter;
              }
            }
          }
          break;

        case " ":
          if (_currentPhase === phase.none) {
            setStartIndexIfNone(i);
          }
          break;

        default:
          if (_currentPhase === phase.none) {
            setStartIndexIfNone(i);
            _currentPhase = phase.lookingForDelimiter;
          }
          break;
      }
    }

    if (_startIndex) {
      const field = _source.substring(_startIndex);
      addField(field);
    }

    return {
      fields: _result,
      index: _source.length - 1,
    };
  }

  return {
    parse: parse,
  };
};
